const API_BASE = process.env.REACT_APP_API_URL || '/api';

const PUBLIC_API_BASE = API_BASE.replace(/\/api\/?$/, '');

export const buildPublicAssetUrl = (assetPath) => {
  if (!assetPath) return '';

  const value = String(assetPath).trim();
  if (!value) return '';

  if (/^(data:|blob:|https?:\/\/)/i.test(value)) {
    return value;
  }

  const normalized = value.startsWith('/') ? value : `/${value}`;

  if (!PUBLIC_API_BASE) {
    return normalized;
  }

  return `${PUBLIC_API_BASE}${normalized}`;
};

export default buildPublicAssetUrl;
